<template>
  <v-app-bar clipped-left app fixed min-width="960" v-if="$route.meta.displayAppBar">
    <v-toolbar-title>
      <v-row align="center" justify="center" no-gutters>
        <img :src="require('@/assets/appLogo-color--Onlight.svg')" width="100"/>
      </v-row>
    </v-toolbar-title>
    <template v-if="$store.state.auth.account.id && $route.meta.displayOrganization">
      <v-btn  @click="$router.push({name: 'AccountChoose'})" text small :ripple="false">
        <span class="ml-4 body-1 text--secondary font-weight-medium text-truncate" style="max-width:200px;">{{$store.state.auth.account.name}}</span>
      </v-btn>

      <!-- search bar component -->
      <search-bar />
      <!-- end search bar component -->

    </template>

    <v-spacer />

    <template v-if="$store.state.auth.account.id && $route.meta.displayOrganization">
      <!-- test mode toggle -->
      <v-tooltip bottom :color="$store.state.ui.testMode ? 'orange darken-3' : 'secondary'" transition="scale-transition">
        <template v-slot:activator="{on, attrs}">
          <v-btn class="mx-1" v-bind="attrs" v-on="on" @click="$store.commit('ui/SET_TEST_MODE', !$store.state.ui.testMode)" color="orange darken-3" height="36" :outlined="!$store.state.ui.testMode" :ripple="false" x-small>
            <v-badge bordered color="red" dot :value="$store.state.ui.testMode" :offset-x="-3" :offset-y="-3">
              <v-icon :color="$store.state.ui.testMode ? 'white' : 'secondary'" size="18">mdi-test-tube</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <span class="white--text caption">
          <template v-if="$store.state.ui.testMode">Deshabilitar modo prueba</template>
          <template v-else>Habilitar modo prueba</template>
        </span>
      </v-tooltip>
      <!-- end test mode toggle -->

      <!-- quickstart toggle -->
      <v-tooltip bottom color="secondary" transition="scale-transition" open-delay="500">
        <template v-slot:activator="{on, attrs}">
          <v-btn class="mx-1" v-bind="attrs" v-on="on" @click="$store.commit('ui/TOGGLE_QUICKSTART_DRAWER')" height="36" outlined :ripple="false" x-small>
            <v-badge bordered color="red" dot :offset-x="-3" :offset-y="-3" :value="quickstartBadge">
              <v-icon class="text--secondary" size="18">mdi-rocket-launch</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <span class="white--text caption">Centro de incorporación</span>
      </v-tooltip>
      <!-- end quickstart toggle -->

      <!-- help menu -->
      <v-menu v-model="helpMenu" close-on-click close-on-content-click offset-y :nudge-bottom="18" min-width="280px" transition="slide-y-transition">
        <template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
          <v-tooltip bottom color="secondary" transition="scale-transition" :disabled="helpMenu" open-delay="500">
            <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
              <v-btn class="mx-1" v-bind="{ ...menuAttrs, ...tooltipAttrs }" v-on="{ ...tooltipOn, ...menuOn }" height="36" outlined :ripple="false" x-small>
                <v-icon class="text--secondary" size="18">mdi-help-circle</v-icon>
              </v-btn>
            </template>
            <span class="white--text caption">Centro de ayuda</span>
          </v-tooltip>
        </template>
        <v-row class="px-5 py-2 background" align="center">
          <v-col cols="4">
            <v-tooltip bottom max-width="180px" transition="scale-transition">
              <template v-slot:activator="{ on }">
                <v-card v-on="on" hover @click="intercomShow">
                  <v-card-text class="text-center">
                    <v-responsive class="align-center" :aspect-ratio="1/1">
                      <v-icon size="28px" color="secondary">mdi-chat</v-icon>
                    </v-responsive>
                  </v-card-text>
                </v-card>
              </template>
              <span>Preguntar en el chat</span>
            </v-tooltip>
          </v-col>
          <v-col cols="4">
            <v-tooltip bottom max-width="180px" transition="scale-transition">
              <template v-slot:activator="{ on }">
                <v-card v-on="on" hover :href="`${$DOCS_BASE}/docs`" target="_blank" :ripple="false">
                  <v-card-text class="text-center">
                    <v-responsive class="align-center" :aspect-ratio="1/1">
                      <v-icon size="28px" color="secondary">mdi-book-open-variant</v-icon>
                    </v-responsive>
                  </v-card-text>
                </v-card>
              </template>
              <span>Guía de uso</span>
            </v-tooltip>
          </v-col>
          <v-col cols="4">
            <v-tooltip bottom max-width="180px" transition="scale-transition">
              <template v-slot:activator="{ on }">
                <v-card v-on="on" hover :href="externalLinks.youtube" target="_blank" :ripple="false">
                  <v-card-text class="text-center">
                    <v-responsive class="align-center" :aspect-ratio="1/1">
                      <v-icon size="32px" color="secondary">mdi-youtube</v-icon>
                    </v-responsive>
                  </v-card-text>
                </v-card>
              </template>
              <span>Ver tutoriales</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-list class="pa-0">
          <v-list-item class="pt-2 pb-1" :href="`${$DOCS_BASE}/docs/getting-started-implementation_guide`" target="_blank" :ripple="false">
            <v-list-item-title class="subtitle-2 text--secondary font-weight-medium"><v-icon left size="20px" color="secondary">mdi-book-open-page-variant</v-icon>Guía de implementación de Piriod</v-list-item-title>
          </v-list-item>
          <v-list-item class="pt-2 pb-1" :href="externalLinks.developers" target="_blank" :ripple="false">
            <v-list-item-title class="subtitle-2 text--secondary font-weight-medium"><v-icon left size="20px" color="secondary">mdi-code-tags</v-icon>Desarrolladores</v-list-item-title>
          </v-list-item>
          <v-list-item class="py-1" :href="externalLinks.ithinki" target="_blank" :ripple="false">
            <v-list-item-title class="subtitle-2 text--secondary font-weight-medium"><v-icon left size="20px" color="secondary">mdi-bullhorn</v-icon>Enviar una sugerencia</v-list-item-title>
          </v-list-item>
          <v-list-item class="pt-1 pb-2" :href="`${$DOCS_BASE}/terms/`" target="_blank" :ripple="false">
            <v-list-item-title class="subtitle-2 text--secondary font-weight-medium"><v-icon left size="20px" color="secondary">mdi-bookmark</v-icon>Condiciones de uso</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <!-- end help menu -->

      <!-- notification menu -->
      <notifications />
      <!-- end notification menu -->

      <v-divider class="ml-2" inset vertical/>
    </template>
    <v-menu close-on-click close-on-content-click offset-y :nudge-bottom="18" transition="slide-y-transition">
      <template v-slot:activator="{on}">
        <v-btn class="ml-3 mr-0" text icon v-on="on" :ripple="false"><img :src="require('@/assets/appIcon-menu-User.svg')" width="38" /></v-btn>
      </template>
      <v-list class="pa-0">
        <v-list-item class="px-5 py-2" :to="{ name: 'AuthSettings' }" :ripple="false">
          <v-list-item-title class="subtitle-2 text--secondary font-weight-medium">Cuenta de usuario</v-list-item-title>
        </v-list-item>
        <v-divider />
        <v-list-item class="px-5 py-2" @click="$store.dispatch('auth/DELETE_AUTH')" :ripple="false">
          <v-list-item-title class="subtitle-2 text--secondary font-weight-medium"><v-icon left size="20px" color="secondary">mdi-exit-to-app</v-icon>Cerrar sesión</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>
<script>
import SearchBar from '@/components/menu/SearchBar'
import Notifications from '@/components/menu/Notifications'
import moment from 'moment'

export default {
  components: {
    SearchBar,
    Notifications
  },
  data: () => ({
    helpMenu: false,
    businessAccount: [
      {
        title: 'Configuración',
        link: 'AccountBasic'
      },
      {
        title: 'Cambiar empresa',
        link: 'AccountChoose'
      }
    ],
    links: ['Home', 'Contacts', 'Settings'],
    externalLinks: {
      developers: 'https://www.piriod.com/developers/',
      ithinki: 'https://piriod.ithinki.io/b/feedback',
      youtube: 'https://www.youtube.com/channel/UCyW-eqWzW6jiPDWb2N5e0qQ'
    }
  }),
  computed: {
    quickstartBadge () {
      if (!this.$store.state.auth.account.created) {
        return false
      }

      const diff = moment().diff(moment(this.$store.state.auth.account.created), 'days')

      if (diff > 14) {
        return false
      }
      return true
    }
  },
  methods: {
    intercomShow () {
      if (process.env.NODE_ENV === 'production') {
        window.Intercom('show')
      }
    }
  }
}
</script>
<style scoped>
  .v-list--three-line .v-list-item .v-list-item__content {
    align-self: center !important;
  }
</style>